var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable */
import { PluginContainerData } from './common';
var baseTableData = {};
export var TableData = {
    fromJSON: function (object) {
        var message = __assign({}, baseTableData);
        if (object.containerData !== undefined && object.containerData !== null) {
            message.containerData = PluginContainerData.fromJSON(object.containerData);
        }
        else {
            message.containerData = undefined;
        }
        if (object.dimensions !== undefined && object.dimensions !== null) {
            message.dimensions = TableData_Dimensions.fromJSON(object.dimensions);
        }
        else {
            message.dimensions = undefined;
        }
        if (object.header !== undefined && object.header !== null) {
            message.header = Boolean(object.header);
        }
        else {
            message.header = undefined;
        }
        if (object.rowHeader !== undefined && object.rowHeader !== null) {
            message.rowHeader = Boolean(object.rowHeader);
        }
        else {
            message.rowHeader = undefined;
        }
        if (object.columnHeader !== undefined && object.columnHeader !== null) {
            message.columnHeader = Boolean(object.columnHeader);
        }
        else {
            message.columnHeader = undefined;
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        message.containerData !== undefined &&
            (obj.containerData = message.containerData
                ? PluginContainerData.toJSON(message.containerData)
                : undefined);
        message.dimensions !== undefined &&
            (obj.dimensions = message.dimensions
                ? TableData_Dimensions.toJSON(message.dimensions)
                : undefined);
        message.header !== undefined && (obj.header = message.header);
        message.rowHeader !== undefined && (obj.rowHeader = message.rowHeader);
        message.columnHeader !== undefined && (obj.columnHeader = message.columnHeader);
        return obj;
    },
};
var baseTableData_Dimensions = { colsWidthRatio: 0, rowsHeight: 0, colsMinWidth: 0 };
export var TableData_Dimensions = {
    fromJSON: function (object) {
        var message = __assign({}, baseTableData_Dimensions);
        message.colsWidthRatio = [];
        message.rowsHeight = [];
        message.colsMinWidth = [];
        if (object.colsWidthRatio !== undefined && object.colsWidthRatio !== null) {
            for (var _i = 0, _a = object.colsWidthRatio; _i < _a.length; _i++) {
                var e = _a[_i];
                message.colsWidthRatio.push(Number(e));
            }
        }
        if (object.rowsHeight !== undefined && object.rowsHeight !== null) {
            for (var _b = 0, _c = object.rowsHeight; _b < _c.length; _b++) {
                var e = _c[_b];
                message.rowsHeight.push(Number(e));
            }
        }
        if (object.colsMinWidth !== undefined && object.colsMinWidth !== null) {
            for (var _d = 0, _e = object.colsMinWidth; _d < _e.length; _d++) {
                var e = _e[_d];
                message.colsMinWidth.push(Number(e));
            }
        }
        return message;
    },
    toJSON: function (message) {
        var obj = {};
        if (message.colsWidthRatio) {
            obj.colsWidthRatio = message.colsWidthRatio.map(function (e) { return e; });
        }
        else {
            obj.colsWidthRatio = [];
        }
        if (message.rowsHeight) {
            obj.rowsHeight = message.rowsHeight.map(function (e) { return e; });
        }
        else {
            obj.rowsHeight = [];
        }
        if (message.colsMinWidth) {
            obj.colsMinWidth = message.colsMinWidth.map(function (e) { return e; });
        }
        else {
            obj.colsMinWidth = [];
        }
        return obj;
    },
};
//# sourceMappingURL=plugin_table.js.map